<template>
  <div class="step2">
    <info-panel class="info">
      <span>
        <el-image
          class="avatar"
          :src="info.wechatAvatarUrl "
        />
      </span>
      <span class="info-item">
        手机号码:<b>{{ info.mobilePhone }}</b>
      </span>
      <span class="info-item">
        微信昵称:<b>{{ info.wechatNickName }}</b>
      </span>
    </info-panel>
    <form-title>账号信息</form-title>
    <info-panel>
      <el-form
        ref="creatStep2Form"
        :model="creatStep2Form"
        :rules="creatStep2Rules"
        label-width="80px"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="用户名"
              prop="loginName"
            >
              <el-input v-model="creatStep2Form.loginName" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="密码">
              <el-button
                v-if="isEdit"
                type="primary"
                @click="resetPsw"
              >
                重置密码
              </el-button>
              <el-input
                v-else
                v-model="creatStep2Form.password"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="真实姓名"
              prop="realName"
            >
              <el-input v-model="creatStep2Form.realName" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 如果选择老师 -->
        <!-- 如果选择老师 end -->
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="身份信息"
              prop="identityType"
            >
              <el-select
                v-model="creatStep2Form.identityType"
                filterable
                clearable
                placeholder="请选择身份信息"
              >
                <el-option
                  v-for="item in identityInformation"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="状态"
              prop="identityValid"
            >
              <el-radio-group v-model="creatStep2Form.identityValid">
                <el-radio :label="types.INDENTITY_VALID_ENABLE">
                  启用
                </el-radio>
                <el-radio :label="types.INDENTITY_VALID_DISABLE">
                  禁用
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 如果选择老师 -->
        <el-row
          v-if="isShowTeacher"
          :gutter="20"
        >
          <el-col :span="6">
            <el-form-item
              label="老师照片"
              prop="teacherPic"
            >
              <upload
                :file-list.sync="creatStep2Form.teacherPic"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="老师标签"
              prop="teacherIntro"
            >
              <el-input
                v-model="creatStep2Form.teacherIntro"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="老师介绍"
              prop="teacherDesc"
            >
              <el-input
                v-model="creatStep2Form.teacherDesc"
                type="textarea"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="在小程序讲师精选中展示"
              class="custome-label"
              prop="teacherIsShowMp"
            >
              <el-switch
                v-model="creatStep2Form.teacherIsShowMp"
                type="textarea"
                :active-value="types.IS_SHOW_MAP_ENABLE"
                :inactive-value="types.IS_SHOW_MAP_DISABLE"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="绑定课程"
              prop="identityType"
            >
              <el-select
                v-model="creatStep2Form.teacherAuditCourseList"
                filterable
                clearable
                placeholder="请选择绑定课程"
                multiple
              >
                <el-option
                  v-for="item in courseList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 如果选择老师 end -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="备注"
              prop="remark"
            >
              <el-input
                v-model="creatStep2Form.identityRemark"
                type="textarea"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col class="btns">
            <el-button
              :disabled="isEdit"
              @click="prev"
            >
              上一步
            </el-button>
            <el-button
              type="primary"
              @click="next"
            >
              下一步
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </info-panel>
  </div>
</template>
<script>
import infoPanel from '@/components/common/infoPanel.vue';
import formTitle from '@/components/common/formTitle.vue';
import upload from '@/components/common/upload/upload.vue';
import types, { identityInformation } from '@/config';
import axClient from '@/services';
import avatarImg from '@/assets/images/header/avatar.png';

export default {
  name: 'CreatStep1',
  components: { infoPanel, formTitle, upload },
  props: {
    info: {
      default: () => ({
        id: '',
        mobilePhone: '',
        wechatNickName: '',
        wechatAvatarUrl: '',
      }),
      type: Object,
    },
    form: {
      default: () => ({
        loginName: null, // 用户名
        realName: null, // 真实姓名
        identityType: types.ADMINISTRATOR, // 身份信息
        identityValid: types.INDENTITY_VALID_ENABLE, // 状态
        identityRemark: null, // 备注
        teacherIntro: null, // 老师简介
        teacherDesc: null, // 老师简介
        teacherIsShowMp: types.IS_SHOW_MAP_ENABLE, // 精选是否显示
        teacherAuditCourseList: [],
      }),
      type: Object,
    },
  },
  data() {
    return {
      types,
      avatarImg,
      identityInformation, // 身份信息配置
      isEdit: !!this.$route.params.id,
      courseList: [], // 绑定课程
      creatStep2Form: {
        loginName: null, // 用户名
        realName: null, // 真实姓名
        password: '默认密码为:123456',
        identityType: types.ADMINISTRATOR, // 身份信息
        identityValid: types.INDENTITY_VALID_ENABLE, // 状态
        identityRemark: null, // 备注
        teacherIntro: null, // 老师简介
        teacherPic: '',
        teacherDesc: null,
        teacherIsShowMp: types.IS_SHOW_MAP_ENABLE, // 精选是否显示
        teacherAuditCourseList: [],
      },
      creatStep2Rules: {
        loginName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        realName: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    isShowTeacher() {
      return this.creatStep2Form.identityType === types.TEACHER;
    },
  },
  mounted() {
    if (this.isEdit) {
      this.creatStep2Form = { ...this.form };
    }
    this.getCourseList();
  },
  methods: {
    // 获取课程列表
    async getCourseList() {
      this.courseList = await axClient.points.listCourseClassName();
    },
    // 上传的路径
    getFilePath(path) {
      this.creatStep2Form.teacherPic = path;
    },
    // 重置密码
    resetPsw() {
      this.$confirm('密码将重置为123456', '确定重置密码？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const data = await axClient.account.resetPsw(
          {
            id: this.$route.params.id,
          },
        );
        if (data) {
          this.$message.success('重置密码成功');
        }
      });
    },
    // 上一步
    prev() {
      this.$emit('prev', 1);
    },
    // 下一步
    next() {
      this.$refs.creatStep2Form.validate(async (valid) => {
        if (valid) {
          this.$emit('next', this.creatStep2Form);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.step2 {
  .info {
    display: flex;
    align-items: center;
    color: $--base-color-black;
    font-size: 14px;
    margin-bottom: 20px;
    .info-item {
      margin-left: 40px;
      b {
        margin-left: 10px;
      }
    }
    .avatar {
      img {
        border-radius: 50%;
        display: inline-block;
        width: 32px;
        height: 32px;
        background: #eee;
      }
    }
  }
}
</style>